import axios from "axios";
import qs from "qs";
const service = axios.create({
  baseURL: "/api/zydl_trade",
  timeout: 20000,
});

const data = {
  status: 0,
  info: "网络出问题了，请稍后重试",
};

// Request interceptors
service.interceptors.request.use(
  (config) => {
    // Add X-Access-Token header to every request, you can add other custom headers here
    if (config.method === "post" || config.method === "POST") {
      if (config.headers["Content-Type"] === "application/json") {
        return config;
      }
      if (config.data) config.data = qs.stringify(config.data);
    }
    return config;
  },
  () => {
    return data;
  }
);

// Response interceptors
service.interceptors.response.use(
  (response) => {
    return response.data;
  },
  () => {
    return data;
  }
);

export default service;
